import { useRef } from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";

import { ReactComponent as DefaultLeftIcon } from "../../../../assets/icons/landing/left.svg";
import { ReactComponent as DefaultRightIcon } from "../../../../assets/icons/landing/right.svg";
import ImageNotFound from "../../../../assets/images/image-not-found.jpg";

const ImagesCustomSwiper = ({ items, setPreviewImg }) => {
  const rtl = document.body.dir === "rtl";

  const swiperRef = useRef();

  console.log(setPreviewImg);
  return (
    <>
      <div className="btn" onClick={() => swiperRef.current?.slidePrev()}>
        {rtl ? <DefaultRightIcon /> : <DefaultLeftIcon />}
      </div>
      <Swiper
        rtl={rtl}
        slidesPerView={4}
        spaceBetween={20}
        breakpoints={{
          2560: {
            slidesPerView: items?.length > 3 ? 4 : items?.length,
          },
          1440: {
            slidesPerView: items?.length > 3 ? 4 : items?.length,
          },
          1024: {
            slidesPerView: items?.length > 3 ? 4 : items?.length,
          },
          768: {
            slidesPerView: items?.length > 3 ? 4 : items?.length,
            spaceBetween: 12,
          },
          500: {
            slidesPerView: items?.length > 2 ? 2 : items?.length,
            spaceBetween: 10,
          },
          425: {
            slidesPerView: items?.length > 1 ? 2 : items?.length,
            spaceBetween: 8,
          },
          375: {
            slidesPerView: items?.length > 1 ? 2 : items?.length,
            spaceBetween: 8,
          },
        }}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {items?.map((el, index) => (
          <SwiperSlide key={el?.service_id}>
            <img
              src={el?.thumbnail || ImageNotFound}
              alt="img"
              onClick={() => setPreviewImg(el.service_id)}
              style={{ cursor: "pointer", objectFit: "fill" }}
            />
            <p className="swiper-title">{el?.service_name}</p>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="btn" onClick={() => swiperRef.current?.slideNext()}>
        {rtl ? <DefaultLeftIcon /> : <DefaultRightIcon />}
      </div>
    </>
  );
};

export default ImagesCustomSwiper;
